var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 66,
    height: 56,
    transform: "translate(0.225 -0.021)",
    fill: "#2c2b34"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8758",
    "data-name": "Group 8758",
    transform: "translate(-0.685 -0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.46 0.417)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M58.058,33.558h-3.1l-4.262-7.1a8.453,8.453,0,0,0-7.211-4.083H23.14a6.648,6.648,0,0,0-6.2,4.2L14.39,32.95c-.065.163-.089.336-.148.5a10.813,10.813,0,0,1-9.768-10.73v-.7A10.849,10.849,0,0,1,15.312,11.186H22.56A8.482,8.482,0,0,0,30.842,17.9h6a3.416,3.416,0,0,0,3.213-2.28c.074.007.136.043.213.043h4.474a2.237,2.237,0,0,0,0-4.474H40.27V6.712h4.474a2.237,2.237,0,0,0,0-4.474h-4.7A3.423,3.423,0,0,0,36.845,0h-6a2.237,2.237,0,0,0,0,4.474H35.8v8.949H30.842a4,4,0,0,1-4-4,2.161,2.161,0,0,0-.049-.239,2.161,2.161,0,0,0,.049-.239,2.238,2.238,0,0,0-2.237-2.237h-9.3A15.33,15.33,0,0,0,0,22.023v.7A15.325,15.325,0,0,0,13.43,37.905c0,.02-.007.04-.007.06v8.108a5.389,5.389,0,0,0,5.383,5.383h1.741a6.672,6.672,0,0,0,12.6,0H45.156a6.672,6.672,0,0,0,12.6,0h3.978a5.388,5.388,0,0,0,5.383-5.383V42.617a9.069,9.069,0,0,0-9.059-9.059M43.487,26.847a3.951,3.951,0,0,1,3.374,1.913l2.882,4.8H40.27V26.847ZM17.9,46.073V37.966a8.953,8.953,0,0,1,.647-3.354l2.55-6.383a2.194,2.194,0,0,1,2.045-1.383H35.8v6.712H24.609a2.237,2.237,0,0,0,0,4.474H35.8v8.949H33.147a6.672,6.672,0,0,0-12.6,0H18.806a.909.909,0,0,1-.908-.908m8.949,5.383a2.237,2.237,0,1,1,2.237-2.237,2.239,2.239,0,0,1-2.237,2.237m24.609,0a2.237,2.237,0,1,1,2.237-2.237,2.238,2.238,0,0,1-2.237,2.237m11.186-5.383a.91.91,0,0,1-.908.908H57.756a6.672,6.672,0,0,0-12.6,0H40.27V38.033H58.058a4.589,4.589,0,0,1,4.584,4.584Z",
    transform: "translate(-0.299 -0.32)",
    fill: "#2c2b34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTCar);
export default __webpack_public_path__ + "static/media/t_car.de7f0051f669b81445f90988448a86ab.svg";
export { ForwardRef as ReactComponent };